import React, { Component } from 'react';
import _ from 'lodash';

import PositionsUserTable from '../PositionsUserTable';
import MultiplePositionsUserTable from '../MultiplePositionsUserTable';
import MultipleDepartmentGroupTable from '../MultipleDepartmentGroupTable';
import SelectedInformee from '../SelectedInformee';
import SelectedDepartmentGroup from '../SelectedDepartmentGroup';

class Forward extends Component {
  constructor(){
    super();

    this.state = {
      current_form: "note",
      selectedInformeeIds: [],
      selectedDepartmentGroupIds: [],
      informeeTargets: [],
      departmentGroupTargets: [],
      current_tab: "nav-internal",
      acting_positions_user_id: null,
      note_text: ""
    }

    this.openInformeeModal = this.openInformeeModal.bind(this);
    this.renderInformeeTarget = this.renderInformeeTarget.bind(this);
    this.renderDepartmentGroupTarget = this.renderDepartmentGroupTarget.bind(this);
    this.handleSelectInformee = this.handleSelectInformee.bind(this);
    this.handleSelectDepartmentGroup = this.handleSelectDepartmentGroup.bind(this);
    this.handleSetTarget = this.handleSetTarget.bind(this);
    this.setInformeeText = this.setInformeeText.bind(this);
    this.handleRemoveTarget = this.handleRemoveTarget.bind(this);
    this.setNoteText = this.setNoteText.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.openTab = this.openTab.bind(this);
    this.isActive = this.isActive.bind(this);
    this.handleShowActors = this.handleShowActors.bind(this);
    this.handleSelectActor = this.handleSelectActor.bind(this);
  }

  openInformeeModal(){
    this.setState({current_form: "selectInformee"});
  }

  handleSelectInformee(selectedInformeeIds){
    this.setState({ selectedInformeeIds: selectedInformeeIds });
  }

  handleSelectDepartmentGroup(selectedDepartmentGroupIds){
    this.setState({ selectedDepartmentGroupIds: selectedDepartmentGroupIds });
  }

  handleSetTarget(){
    // Selected Informees
    const selectedInformeeIds = this.state.selectedInformeeIds;
    let informeeTargets = _.filter(this.props.internal_users, function(i) { return _.includes(selectedInformeeIds, i.id); });
    informeeTargets = informeeTargets.map((t) => {
      return {
        positions_user_id: t.id,
        informee_text: t.position_name,
        informee_name_with_position: `${t.full_name} ${t.position_name} ${t.department_name}`,
        department_group_name: "",
        department_group_members: "",
      }
    })

    // Selected DepartmentGroups
    const selectedDepartmentGroupIds = this.state.selectedDepartmentGroupIds;
    let departmentGroupTargets = _.filter(this.props.department_groups, function(i) { return _.includes(selectedDepartmentGroupIds, i.id); });
    departmentGroupTargets = departmentGroupTargets.map((t) => {
      return {
            id: t.id,
            positions_user_id: t.secretary_positions_user_id,
            department_group_name: t.name,
            department_group_members: t.member_name_with_positions,
            informee_text: t.name,
            informee_name_with_position: "",
      }
    })

    this.setState({
      informeeTargets: informeeTargets,
      departmentGroupTargets: departmentGroupTargets,
      current_form: "note"
    }, () => {
      const { informeeTargets, departmentGroupTargets } = { ...this.state };
      let targets = _.concat(informeeTargets, departmentGroupTargets);

      this.setState({targets: targets});
    });
  }

  setNoteText(event){
    const note_text = event.target.value;
    this.setState({note_text: note_text});
  }

  handleSubmit(){
    this.props.onSubmitAction(this.state.targets, this.state.note_text);
  }

  setInformeeText(event, positions_user_id){
    const informee_text = event.target.value;
    
    const { informeeTargets, departmentGroupTargets } = { ...this.state };
    let targets = _.concat(informeeTargets, departmentGroupTargets);
    const target = _.find(targets, {positions_user_id: positions_user_id})
    target.informee_text = informee_text;

    this.setState({targets: targets});
  }

  handleRemoveTarget(positions_user_id){
    let { informeeTargets, departmentGroupTargets } = { ...this.state };
    _.remove(informeeTargets, {positions_user_id: positions_user_id});
    _.remove(departmentGroupTargets, {positions_user_id: positions_user_id});

    this.setState({
      informeeTargets: informeeTargets,
      departmentGroupTargets: departmentGroupTargets
    }, () => {
      const { informeeTargets, departmentGroupTargets } = { ...this.state };
      let targets = _.concat(informeeTargets, departmentGroupTargets);
      this.setState({targets: targets});
    });
  }

  handleClose(){
    this.setState({current_form: "note"});
  }

  handleShowActors(positions_user_id){
    const acting =  _.find(this.props.actings, (acting) => {
                      return acting.attributes.positions_user.id === positions_user_id
                    });
    const actor_positions_users = acting.attributes.actor_positions_users;

    this.setState({
      actor_positions_users: actor_positions_users,
      acting_positions_user_id: positions_user_id,
      current_form: "selectActor",
    });
  }

  handleSelectActor(row, isSelected, e){
    let targets = [...this.state.targets];
    let target = _.find(targets, {positions_user_id: this.state.acting_positions_user_id});

    target.positions_user_id = row.id;
    target.informee_name_with_position = `${row.full_name} ${row.position_name} ${row.department_name}`;

    this.setState({
      targets: targets,
      current_form: "note",
    });
  }

  openTab(tab_id){
    this.setState({ current_tab: tab_id });
  }

  isActive(tab_id){
    if(tab_id === this.state.current_tab){
      return "show active";
    } else {
      return "";
    }
  }
  
  renderInformeeTarget(target, index){
    return (
      <div key={index}>
        <SelectedInformee {...target} 
                          acting_positions_user_ids={this.props.acting_positions_user_ids}
                          setInformeeText={this.setInformeeText}
                          handleRemoveTarget={this.handleRemoveTarget}
                          showActors={this.handleShowActors} />
      </div>
    )
  }
  
  renderDepartmentGroupTarget(target, index){
    return (
      <div key={index}>
        <SelectedDepartmentGroup  {...target} 
                                  setInformeeText={this.setInformeeText}
                                  handleRemoveTarget={this.handleRemoveTarget} />
      </div>
    )
  }

  render(){
    return(
      <div>
        { this.state.current_form === 'note' && (
          <div>
            <div className="row">
              <div className="col-2">เรียน</div>
              <div className="col-10">
                { _.map(this.state.informeeTargets, this.renderInformeeTarget) }
                { _.map(this.state.departmentGroupTargets, this.renderDepartmentGroupTarget) }

                <button className="btn btn-sm btn-primary" onClick={this.openInformeeModal}>เพิ่มผู้ถูกเรียน</button>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <h4>ข้อความ</h4>
                <textarea cols="30" rows="10" className="w-100" value={this.state.note_text} onChange={this.setNoteText}></textarea>
              </div>
            </div>

            <div className="modal-footer row mt-2">
              <button type='button' className="btn btn-primary pointer" disabled={this.props.clicked} onClick={this.handleSubmit}>ยืนยัน</button>
              <button type='button' className="btn btn-secondary pointer" onClick={this.props.onCloseModal}>ยกเลิก</button>
            </div>
          </div>
        )}
        { this.state.current_form === 'selectInformee' && (
          <div>
            <nav className="mb-1">
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <a className={`nav-item nav-link ${this.isActive("nav-internal")}`} id="nav-internal-tab" data-toggle="tab" href="#nav-internal" role="tab" aria-controls="nav-internal" aria-selected="true"
                    onClick={() => this.openTab("nav-internal")}>
                  หน่วยงานภายใน
                </a>
                <a className={`nav-item nav-link ${this.isActive("nav-department-groups")}`} id="nav-department-groups-tab" data-toggle="tab" href="#nav-department-groups" role="tab" aria-controls="nav-department-groups" aria-selected="false"
                    onClick={() => this.openTab("nav-department-groups")}>
                  สารบรรณหน่วยงาน
                </a>
              </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
              <div className={`tab-pane fade ${this.isActive("nav-internal")}`} id="nav-internal" role="tabpanel" aria-labelledby="nav-internal-tab">
                <MultiplePositionsUserTable positions_users={this.props.internal_users}
                                            selectedIds={this.state.selectedInformeeIds}
                                            onSelectInformee={this.handleSelectInformee} />
              </div>
              <div className={`tab-pane fade ${this.isActive("nav-department-groups")}`} id="nav-department-groups" role="tabpanel" aria-labelledby="nav-department-groups-tab">
                <MultipleDepartmentGroupTable department_groups={this.props.department_groups}
                                              selectedIds={this.state.selectedDepartmentGroupIds}
                                              onSelectDepartmentGroup={this.handleSelectDepartmentGroup} />
              </div>
            </div>

            <div className="modal-footer col-12">
              <button type='button' className="btn btn-primary pointer" onClick={this.handleSetTarget}>ยืนยันที่เลือก</button>
              <button type='button' className="btn btn-secondary pointer" onClick={this.handleClose}>ยกเลิก</button>
            </div>
          </div>
        )}
        { this.state.current_form === 'selectActor' && (
          <PositionsUserTable positions_users={this.state.actor_positions_users}
                              onSelect={this.handleSelectActor}
                              onClose={this.handleClose} />
        )}
      </div>
    )
  }
}

export default Forward;


// WEBPACK FOOTER //
// ./src/components/WorkflowActions/Forward.js